import { post,put,del,get,get2 } from './axios'


export const loginUser = async (params) => {
  const { status, data } = await post("/user/loginUserAjax", params)

  if (status === 200 || status === 201) {
      return data
  }
}

export const sendJoinNum = async (params) => {
  const { status, data } = await post("/user/sendJoinNum", params)

  if (status === 200 || status === 201) {
      return data
  }
}

export const checkJoinNum = async (params) => {
  const { status, data } = await post("/user/checkJoinNumAjax", params)

  if (status === 200 || status === 201) {
      return data
  }
}

export const reSendJoinNum = async (params) => {
  const { status, data } = await post("/user/reSendJoinNum", params)

  if (status === 200 || status === 201) {
      return data
  }
}

export const joinUser = async (params) => {
  const { status, data } = await post("/user/joinUserAjax", params)

  if (status === 200 || status === 201) {
      return data
  }
}

export const detailUser = async (params) => {
  const { status, data } = await get("/user/detailUserAjax", params)

  if (status === 200 || status === 201) {
      return data
  }
}

export const increaseDailyVisitr = async (params) => {
  const { status, data } = await post("/user/increaseDailyVisitrAjax", params)

  if (status === 200 || status === 201) {
      return data
  }
}

export const selectAllVisits = async (params) => {
  const { status, data } = await get("/user/selectAllVisitsAjax", params)

  if (status === 200 || status === 201) {
      return data
  }
}

export const passwordResetRequest = async (params) => {
  const { status, data } = await post("/user/passwordReset/request", params)

  if (status === 200 || status === 201) {
      return data
  }
}

export const passwordResetVerify = async (params) => {
  const { status, data } = await post("/user/passwordReset/verify", params)

  if (status === 200 || status === 201) {
      return data
  }
}

export const passwordResetConfirm = async (params) => {
  const { status, data } = await post("/user/passwordReset/confirm", params)

  if (status === 200 || status === 201) {
      return data
  }
}

export const searchUserIdAjax = async (params) => {
  const { status, data } = await post("/user/searchUserIdAjax", params)

  if (status === 200 || status === 201) {
      return data
  }
}